import { NavLink } from "react-router-dom";
import { MdSupportAgent, MdMeetingRoom, MdDelete } from "react-icons/md";
import { FaDatabase, FaUpload } from "react-icons/fa";
import "../commoncss/Sidebar.css";
import { TbLogout2 } from "react-icons/tb";
import { IoTrailSign } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { RiAdminFill } from "react-icons/ri";

const AdminSidebar = () => {
  const navigate = useNavigate();
  const cookies = new Cookies();

  return (
    <>
      <div className="sideBar">
        <div className="sidebar_header">
          <div className="sidebar_graphic">
            <div className="graphic_orb orb_1"></div>
            <div className="graphic_orb orb_2"></div>
            <div className="graphic_orb orb_3"></div>
            <div className="graphic_icon">
              <RiAdminFill />
            </div>
          </div>
        </div>
        <p>Admin Panel</p>
        {/* <li>
          <NavLink to="dashboard">
            <RiAdminFill className="nav_icon" />
            <span>Dashboard</span>
          </NavLink>
        </li> */}
        <li>
          <NavLink to="agent">
            <MdSupportAgent className="nav_icon" />
            <span>Agents</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="data">
            <FaDatabase className="nav_icon" />
            <span>Data</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="upload">
            <FaUpload className="nav_icon" />
            <span>Upload</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="detailed">
            <IoTrailSign className="nav_icon" />
            <span>Trail</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="deletedata">
            <MdDelete className="nav_icon" />
            <span>Delete Agent Data</span>
          </NavLink>
        </li>
        {/* <li>
                    <NavLink to="profile">
                        <FaUser className="nav_icon" />
                        <span>Profile</span>
                    </NavLink>
                </li> */}
        <li>
          <NavLink to="rooms">
            <MdMeetingRoom className="nav_icon" />
            <span>Rooms</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="subadmin">
            <RiAdminFill className="nav_icon" />
            <span>Sub Admin</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="admin"
            onClick={(e) => {
              e.preventDefault();
              cookies.remove("admin");
              navigate("/admin");
            }}
          >
            <TbLogout2 className="nav_icon" />
            <span>Log Out</span>
          </NavLink>
        </li>
      </div>
    </>
  );
};

export default AdminSidebar;
